import React from 'react'
import PropTypes from 'prop-types';
import PreparingAdditionalInfo from "./PreparingAdditionalInfo";
import {DemandValidation, DemandValidationKeys} from "constants/DemandValidation";


function Index(
    {
        expanded
    }) {
    return expanded && <PreparingAdditionalInfo sectionId={DemandValidation.PREPARING_ADDITIONAL_INFO} formId={DemandValidationKeys.PREPARING_ADDITIONAL_INFO}/>
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;